import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { LibFormContainerModule } from '../form-container/form-container.module';
import { TranslateAuthorityPipe } from './translate-authority.pipe';
import { UserDeleteDialogComponent } from './user-delete-dialog/user-delete-dialog.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserManagementService } from './user-management.service';
import { UserSetPasswordDialogComponent } from './user-set-password-dialog/user-set-password-dialog.component';
import { UsersListComponent } from './users-list/users-list.component';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        LibFormContainerModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatCheckboxModule,
        MatAutocompleteModule,
    ],
    exports: [UsersListComponent, UserDetailComponent, UserDeleteDialogComponent],
    declarations: [UsersListComponent, UserDetailComponent, UserDeleteDialogComponent, TranslateAuthorityPipe, UserSetPasswordDialogComponent],
})
export class LibAdminModule {
    static forRoot(): ModuleWithProviders<LibAdminModule> {
        return {
            ngModule: LibAdminModule,
            providers: [UserManagementService],
        };
    }
}
